import {
  CSSProperties,
  FC,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'
import { NextPage } from 'next'
import useTranslation from 'next-translate/useTranslation'
import hybrid from '@mobiuspace/larkplayer-hybrid'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'
import Div100vh, { use100vh } from 'react-div-100vh'
import classnames from 'classnames'
import axios from 'axios'
import API from '@/services/music-recap'
import intent from '@/utils/intent'
import { selectGlobal } from '@/store/global'
import { useAppSelector } from '@/store/hooks'
import gsap from 'gsap'
import { regionList, arRegionList } from '@/utils/music-recap/const'
import MySwiper from '@/components/music-recap/Swiper'
import icLogo from '@/images/music-recap/ic_logo.png'
import icDownload from '@/images/music-recap/ic_download.png'
import icDot from '@/images/music-recap/dot.svg'
import icLine from '@/images/music-recap/line.svg'
import icShare from '@/images/music-recap/ic_share.png'
import icShareBlack from '@/images/music-recap/ic_share_b.png'
import icSound from '@/images/music-recap/ic_sound.png'
import icMuted from '@/images/music-recap/ic_muted.png'
import icClose from '@/images/music-recap/ic_close.png'
import icRefresh from '@/images/music-recap/ic_refresh.png'
import icStartArrow from '@/images/music-recap/ic_arrow_up.png'
import icArtist from '@/images/music-recap/ic_ artist_filled.png'
import icSong from '@/images/music-recap/ic_ song_filled.png'
import icPlaytime from '@/images/music-recap/ic_playtime_filled.png'
import icRanking from '@/images/music-recap/ic_ranking_filled.png'
import startBG from '@/images/music-recap/yearly_btn.png'
import styles from './index.module.scss'

const i18ns = 'music-recap'

const timeList = {
  page1: 12,
  page2: 8,
  page3: 8,
  page4: 8,
  page5: 8,
  page6: 8,
  page7: 10,
  page8: 8,
  page9: 10,
  page10: 10,
  page11: 10,
}

type StartProps = {
  track: any
  onClick: any
  dataTime: number
}
const RenderPage0: FC<StartProps> = ({ track, onClick, dataTime }) => {
  const { t, lang } = useTranslation(i18ns)
  const [count, addCount] = useState(0)
  const [initalLoading, setIniLoading] = useState(true)

  const gotoAgreement = () => {
    try {
      hybrid.handleBrowserAction(
        lang === 'es'
          ? 'https://larkplayer.zendesk.com/hc/es-mx/articles/27956184571159-T%C3%A9rminos-de-uso-Recuerdos-2024?lp_and_widget=12'
          : lang === 'pt'
          ? 'https://larkplayer.zendesk.com/hc/pt-br/articles/27956184571159-Termos-de-Uso-Mem%C3%B3rias-2024?lp_and_widget=12'
          : lang === 'ar'
          ? 'https://larkplayer.zendesk.com/hc/ar/articles/27956184571159-%D8%B4%D8%B1%D9%88%D8%B7-%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%AF%D8%A7%D9%85-%D8%A7%D9%84%D8%B0%D9%83%D8%B1%D9%8A%D8%A7%D8%AA-2024?lp_and_widget=12'
          : lang == 'fr'
          ? 'https://larkplayer.zendesk.com/hc/fr/articles/27956184571159-Conditions-d-Utilisation-Souvenirs-2024?lp_and_widget=12'
          : 'https://larkplayer.zendesk.com/hc/en-us/articles/27956184571159-Terms-of-Use-Memories-2024?lp_and_widget=12'
      )
    } catch (error) {
      console.log('error: ', error)
    }
  }

  // 模拟加载百分数
  useEffect(() => {
    const interval = setInterval(() => {
      // 创建定时器
      const len = 100
      if (count >= len) {
        setIniLoading(false)
        clearInterval(interval)
      } else {
        addCount((val) => val + 10)
        setIniLoading(true)
      }
    }, dataTime)
    return () => {
      clearInterval(interval) // 清除定时器
    }
  }, [count, dataTime])

  // 文字加载动画
  useEffect(() => {
    const startLoad = sessionStorage.getItem('startLoading')
    // @ts-ignore
    const pageShowTime = startLoad && (Date.now() - startLoad) / 1000

    track('$AppViewScreen', {
      $url: '/music_memories/home/waiting',
      content_type: 'normal',
      event_url: window.location.host,
      page_show_time: pageShowTime,
    })

    const elements = document.querySelectorAll('p')
    const tl = gsap.timeline()
    gsap.set(elements, { y: 100, opacity: 0 })

    tl.to(
      elements[0],
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    ).to(elements[1], { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 2)
  }, [])

  return (
    <div
      className={styles.wrapper}
      style={{ position: 'relative' }}
      dir={lang == 'ar' ? 'rtl' : 'ltr'}
    >
      <div className={styles.content}>
        <div className={styles.box}>
          <p className={styles.title}>{t('y主标题')}</p>
          <p className={styles.subTitle}>2024</p>
        </div>

        <div className={styles.btnBox}>
          <div className={styles.btn}>
            <img src={startBG.src} alt="" className={styles.bg} />
            {/* 测试去掉Lottie */}
            {/* <BtnLottie> */}
            <div className={styles.start}>
              {initalLoading ? (
                <div className={styles.ld} dir="ltr">
                  {count} %
                </div>
              ) : (
                <div dir="ltr" onClick={onClick}>
                  <div dir={lang == 'ar' ? 'rtl' : 'ltr'}>
                    {t('y开始生成按钮')}
                  </div>
                  <img className={styles.icon} src={icStartArrow.src} alt="" />
                </div>
              )}
            </div>
            {/* </BtnLottie> */}
          </div>

          <div className={styles.agreement}>
            <div className={styles.text}>
              {t('y声明')}
              <span className={styles.link} onClick={gotoAgreement}>
                {t('y隐私条款')}.
              </span>
            </div>
          </div>
          <div className={styles.copyright}>
            {
              'Music by Scott Buckley – released under CC-BY 4.0. www.scottbuckley.com.au'
            }
          </div>
        </div>
      </div>
    </div>
  )
}

type Page1Props = {
  page1Data: any
  pageIndex: number
  track: any
  fnBtn?: boolean
  MoreInfo: any
}

const RenderPage1: FC<Page1Props> = ({
  track,
  page1Data,
  pageIndex,
  fnBtn,
  MoreInfo,
}) => {
  const { t, lang } = useTranslation(i18ns)
  {
    /* 如果时间在2024-01-01前，则时间展示为 2024-01-01 的零点零分零秒 */
  }
  const showTime =
    page1Data.firstPlay < 1704038400 ? 1704038400 : page1Data.firstPlay

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 0) return
    track('$AppViewScreen', {
      $url: '/music_memories/begin',
      content_type: 'normal',
    })

    const p4 = document.getElementById('p4')

    const elements = document.getElementById('p1')?.querySelectorAll('.gsap')

    let tl = gsap.timeline()

    elements && gsap.set(elements, { y: 100, opacity: 0 })
    p4 && gsap.set(p4, { y: 100, opacity: 0 })

    elements &&
      elements[2] &&
      track('$AppViewScreen', {
        $url: '/music_memories/total_time',
        content_type: 'normal',
      })

    tl.to(
      // @ts-ignore
      elements[0],
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      0.5
    )
      .to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
      .to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 0, duration: 1, ease: 'power2.out' },
        5
      )
      // @ts-ignore
      .to(elements[1], { y: 0, opacity: 0, duration: 1, ease: 'power2.out' }, 5)
      // @ts-ignore
      .to(elements[2], { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 6)
      .to(
        // @ts-ignore
        elements[3],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        7
      )
    return () => {
      tl.kill()
    }
  }, [pageIndex])

  return (
    <>
      <div id="p1" className={styles.page1Content}>
        <div className={styles.part}>
          <div
            className="gsap"
            style={{ fontSize: '48px', fontWeight: 400, marginBottom: '10vw' }}
          >
            {t('y信息页1')}
          </div>
          <div className="gsap">
            {t('y信息页1-1')}
            <i>
              {t(dayjs.unix(showTime).format('MMM'))}{' '}
              {dayjs.unix(showTime).format('D, YYYY, H:mm A')}
            </i>
          </div>
        </div>
        <div className={styles.part}>
          <div className="gsap" style={{ marginBottom: '10vw' }}>
            {t('y信息页1-2')}
            <i className={styles.num}>{page1Data.playMins}</i>
            <span>{t('y信息页1-listening to music')}</span>
            <div>{t('y信息页1-3')}</div>
          </div>

          <div className="gsap">
            {t('y信息页-For')}
            <i className={styles.num}>{page1Data.playDay}</i>
            <span>{t('y信息页1-4')}</span>
          </div>
        </div>

        {!fnBtn && <MoreInfo />}
      </div>
    </>
  )
}

type Page2Props = {
  page2Data?: any
  pageIndex: number
  track: any
  fnBtn?: boolean
  MoreInfo: any
}

const RenderPage2: FC<Page2Props> = ({
  track,
  page2Data,
  pageIndex,
  fnBtn,
  MoreInfo,
}) => {
  const { t, lang } = useTranslation(i18ns)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 4) return

    const p2 = document.getElementById('p2')
    const p6 = document.getElementById('p6')

    const elements = document.getElementById('p2')?.querySelectorAll('.gsap')

    let tl = gsap.timeline()

    elements && gsap.set(elements, { y: 100, opacity: 0 })
    p6 && gsap.set(p6, { y: 100, opacity: 0 })

    tl.to(p2, { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)
      // @ts-ignore
      .to(elements[0], { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)

    if (elements && page2Data.length > 0) {
      track('$AppViewScreen', {
        $url: '/music_memories/artist_topn',
        content_type: 'normal',
      })
      if (elements[1]) {
        tl.to(
          // @ts-ignore
          elements[1],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          2
        )
      }
      if (elements[2]) {
        tl.to(
          // @ts-ignore
          elements[2],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          3
        )
      }
      if (elements[3]) {
        tl.to(
          // @ts-ignore
          elements[1],
          { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
          8
        )
          .to(
            // @ts-ignore
            elements[2],
            { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
            8
          )
          .to(
            // @ts-ignore
            elements[3],
            { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
            9
          )
      }
    } else {
      tl.to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
    }

    return () => {
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p2" className={styles.page2Content}>
        {page2Data.length > 0 ? (
          <>
            <div className="gsap">{t('y信息页2-收听最多次数多歌手')}</div>
            <div className={styles.part}>
              <div className="gsap">
                <i>
                  {lang == 'ar' ? t('数字1') : 1}. {page2Data[0]}
                </i>
              </div>
              <div className="gsap">
                {page2Data?.slice(1, 5).map((i: string, e: number) => (
                  <p key={e}>
                    {lang == 'ar' ? t(`数字${e + 2}`) : e + 2}. {i}
                  </p>
                ))}
              </div>
            </div>

            {page2Data?.slice(5, 10).length > 0 && (
              <div className={styles.part}>
                <div className="gsap">
                  {page2Data?.slice(5, 10).map((i: string, e: number) => (
                    <p key={e}>
                      {lang == 'ar' ? t(`数字${e + 6}`) : e + 6}. {i}
                    </p>
                  ))}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="gsap" style={{ color: '#fff', top: '30%' }}>
            {t('y信息页2-无artist兜底')}
          </div>
        )}
        {!fnBtn && <MoreInfo />}
      </div>
    </>
  )
}

type Page3Props = {
  page3Data?: any
  pageIndex: number
  track: any
}
const RenderPage3: FC<Page3Props> = ({ track, page3Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)
  const haveValue = page3Data.top1SongArt || page3Data.explorSong
  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 3) return

    const p2 = document.getElementById('p2')
    const p3 = document.getElementById('p3')
    const elements = document.getElementById('p3')?.querySelectorAll('.gsap')

    let tl = gsap.timeline()

    elements && gsap.set(elements, { y: 100, opacity: 0 })
    p2 && gsap.set(p2, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p3,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )

    if (elements && haveValue) {
      tl.to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
      if (elements[1]) {
        track('$AppViewScreen', {
          $url: '/music_memories/top1_artist ',
          content_type: 'normal',
        })
        tl.to(
          // @ts-ignore
          elements[1],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          2
        )
      }
      if (elements[2]) {
        track('$AppViewScreen', {
          $url: '/music_memories/explore_artist',
          content_type: 'normal',
        })
        tl.to(
          // @ts-ignore
          elements[0],
          { y: 0, opacity: 0, duration: 1, ease: 'power2.out' },
          6
        )
          .to(
            // @ts-ignore
            elements[1],
            { y: 0, opacity: 0, duration: 1, ease: 'power2.out' },
            6
          )
          .to(
            // @ts-ignore
            elements[2],
            { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
            7
          )
      }
    } else {
      tl.to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
    }

    return () => {
      tl.kill()
    }
  }, [pageIndex])

  return (
    <>
      <div id="p3" className={styles.page3Content}>
        {haveValue ? (
          <>
            {page3Data.top1SongArt && (
              <div className="gsap">
                <div className={styles.text}>
                  {t('y信息页3-播放次数Top1的歌手')}
                  <i>{page3Data.top1SongArt}</i>
                  <span>{t('y信息页-for')}</span>
                  <i>{page3Data.top1SongPlayDay}</i>
                  <span>{t('y信息页3-播放次数Top1的歌手总时长')}</span>
                  <i className={styles.num}>{page3Data.top1SongPlayMin}</i>
                  <span>{t('分钟')}.</span>
                  <p className="gsap" style={{ margin: '20px 0' }}>
                    {t('y信息页3-描述')}
                  </p>
                </div>
              </div>
            )}

            {page3Data.explorArt && (
              <div className="gsap">
                <span>{t('y信息页3-You had a passion for')}</span>
                <i>{page3Data.explorArt}</i>
                <span>{t('y信息页3-exploring')}</span>
                <i className={styles.num}>{page3Data.explorSong}</i>
                <span style={{ display: 'inline-block' }}>
                  {t('y信息页3-along the way')}
                </span>
              </div>
            )}
          </>
        ) : (
          <div className="gsap">{t('y信息页3-兜底')}</div>
        )}
      </div>
    </>
  )
}

type Page4Props = {
  page4Data?: any
  pageIndex: number
  track: any
}
const RenderPage4: FC<Page4Props> = ({ track, page4Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 1) return
    track('$AppViewScreen', {
      $url: '/music_memories/top1_song',
      content_type: 'normal',
    })

    const p4 = document.getElementById('p4')
    const p5 = document.getElementById('p5')
    const elements = document.getElementById('p4')?.getElementsByTagName('p')

    const tl = gsap.timeline()

    elements && gsap.set(elements, { y: 100, opacity: 0 })
    p5 && gsap.set(p5, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p4,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
      .to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
      .to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 0, duration: 1, ease: 'power2.out' },
        3
      )
      .to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        4
      )
    return () => {
      tl.kill()
    }
  }, [pageIndex])

  return (
    <>
      <div id="p4" className={styles.page4Content}>
        <p className={styles.text}>
          {t('y信息页4-总听歌曲目数')}
          <i className={styles.num}>{page4Data.totalPlaySong}</i>
          <span>{t('y信息页4-总听歌曲目数被播放')}</span>
        </p>
        <p>
          {t('y信息页4-播放次数Top1的歌曲')}
          <i className={styles.songName}>{page4Data.top1SongName}</i>

          {page4Data.top1SongArt && (
            <>
              {' '}
              <span>{t('y信息页-by')}</span>
              <i style={{ marginRight: 0 }}>{page4Data.top1SongArt}</i>{' '}
            </>
          )}
          <span>{t('y信息页4-and you have played it')}</span>
          <i className={styles.num}>{page4Data.top1PlayCnt}</i>
          <span>{t('y信息页-times')}.</span>
        </p>
      </div>
    </>
  )
}

type Page5Props = {
  page5Data?: any
  pageIndex: number
  track: any
  fnBtn?: boolean
  MoreInfo: any
}
const RenderPage5: FC<Page5Props> = ({
  track,
  page5Data,
  pageIndex,
  fnBtn,
  MoreInfo,
}) => {
  const { t, lang } = useTranslation(i18ns)
  const data1 = page5Data?.slice(1, 5)
  const data2 = page5Data?.slice(5, 10)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 2) return

    const p5 = document.getElementById('p5')
    const p3 = document.getElementById('p3')

    const elements = document.getElementById('p5')?.querySelectorAll('.gsap')

    let tl = gsap.timeline()
    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })
    p3 && gsap.set(p3, { y: 100, opacity: 0 })

    // @ts-ignore
    tl.to(p5, { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)
      // @ts-ignore
      .to(elements[0], { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)

    if (elements && elements[1]) {
      track('$AppViewScreen', {
        $url: '/music_memories/song_topn',
        content_type: 'normal',
      })
      tl.to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
    }
    if (elements && elements[2]) {
      tl.to(
        // @ts-ignore
        elements[2],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        3
      )
    }
    if (elements && elements[3]) {
      tl.to(
        // @ts-ignore
        elements[1],
        { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
        8
      )
        .to(
          // @ts-ignore
          elements[2],
          { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
          8
        )
        .to(
          // @ts-ignore
          elements[3],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          9
        )
    }

    return () => {
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p5" className={styles.page5Content}>
        <div className="gsap">{t('y信息页5-播放次数Top10的歌曲')}</div>

        {data1.length > 1 && (
          <div className={styles.part}>
            <div className="gsap">
              <i>
                {lang == 'ar' ? t('数字1') : 1}. {page5Data[0]}
              </i>
            </div>
            <div className="gsap">
              {data1.map((i: string, e: number) => (
                <p key={e}>
                  {lang == 'ar' ? t(`数字${e + 2}`) : e + 2}. {i}
                </p>
              ))}
            </div>
          </div>
        )}

        {data2.length > 0 && (
          <div className={styles.part}>
            <div className="gsap">
              {data2.map((i: string, e: number) => (
                <p key={e}>
                  {lang == 'ar' ? t(`数字${e + 6}`) : e + 6}. {i}
                </p>
              ))}
            </div>
          </div>
        )}
        {!fnBtn && <MoreInfo />}
      </div>
    </>
  )
}

type Page6Props = {
  page6Data?: any
  pageIndex: number
  track: any
}
const RenderPage6: FC<Page6Props> = ({ track, page6Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)
  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 5) return
    track('$AppViewScreen', {
      $url: '/music_memories/playlist ',
      content_type: 'normal',
    })

    const p6 = document.getElementById('p6')
    const p7 = document.getElementById('p7')

    const elements = document.getElementById('p6')?.getElementsByTagName('p')

    const tl = gsap.timeline()

    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })
    p7 && gsap.set(p7, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p6,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    ).to(
      // @ts-ignore
      elements[0],
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
    return () => {
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p6" className={styles.page6Content}>
        {page6Data.top1PlaylistName ? (
          <p>
            {t('y信息页6-Top1自定义歌单名称')}
            <i>{page6Data.top1PlaylistName}</i>
            <span>{t('y信息页6-Top1自定义歌单名称被播放')}</span>
            <i className={styles.num}>{page6Data.top1PlaylistMin}</i>
            <span>{t('y信息页-mins in total')}</span>
          </p>
        ) : (
          <p>{t('y信息页6-兜底')}</p>
        )}
      </div>
    </>
  )
}

type Page7Props = {
  page7Data?: any
  pageIndex: number
  track: any
  fnBtn?: boolean
  MoreInfo: any
  errorData: boolean
}
const RenderPage7: FC<Page7Props> = ({
  track,
  page7Data,
  pageIndex,
  fnBtn,
  MoreInfo,
  errorData,
}) => {
  const { t, lang } = useTranslation(i18ns)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 6) return

    const p7 = document.getElementById('p7')
    const p8 = document.getElementById('p8')
    const elements = document.getElementById('p7')?.getElementsByTagName('p')
    const mList = document.getElementById('p7')?.querySelectorAll('.gsap')

    const tl = gsap.timeline()

    // Initial setup
    elements && gsap.set(elements, { y: 100, opacity: 0 })
    p8 && gsap.set(p8, { y: 100, opacity: 0 })
    mList && gsap.set(mList, { y: 100, opacity: 0 })

    // Base animation for container
    tl.to(p7, { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)

    if (!errorData) {
      // Animate sections sequentially
      const animateSection = (startIndex: number, sectionIndex: number) => {
        const sectionData = page7Data.slice(startIndex, startIndex + 3)
        if (sectionData.length === 0) return

        const baseDelay = sectionIndex * 8 // Increase spacing between sections

        // First section starts with titles
        if (sectionIndex === 0) {
          // First title
          elements?.[0] &&
            tl
              .to(
                elements[0],
                { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
                1
              )
              .to(
                elements[0],
                { y: 0, opacity: 0, duration: 1, ease: 'power2.out' },
                3
              )
              // Second title
              .to(
                elements[1],
                { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
                3.5
              )
        }

        // Track view when section becomes visible
        tl.call(
          () => {
            track('$AppViewScreen', {
              $url: `/music_memories/month_p${sectionIndex + 1}`,
              content_type: 'normal',
            })
          },
          [],
          baseDelay + 3
        )

        // Hide previous section before showing new one
        if (sectionIndex > 0) {
          const prevStartIndex = startIndex - 3
          const prevItems = Array.from(
            { length: 3 },
            (_, i) => mList?.[prevStartIndex + i]
          )

          // Hide previous section's items
          prevItems.forEach((item, i) => {
            item &&
              tl.to(
                item,
                {
                  y: -50,
                  opacity: 0,
                  duration: 0.5,
                  ease: 'power2.out',
                },
                baseDelay + 2 + i * 0.2
              )
          })
        }

        // Animate current section's items
        sectionData.forEach((_: any, itemIndex: number) => {
          const item = mList?.[startIndex + itemIndex]
          if (!item) return

          tl.to(
            item,
            {
              y: 0,
              opacity: 1,
              duration: 1,
              ease: 'power2.out',
            },
            baseDelay + 4 + itemIndex * 0.5 // Start after hiding previous section
          )
        })
      }

      // Animate sections sequentially
      ;[0, 3, 6, 9].forEach((startIndex, index) => {
        animateSection(startIndex, index)
      })
    } else {
      track('$AppViewScreen', {
        $url: '/music_memories/month_p1',
        content_type: 'error',
      })
      tl.to(
        // @ts-ignore
        elements?.[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
    }

    return () => tl.kill()
  }, [pageIndex])
  return (
    <>
      <div
        id="p7"
        className={classnames(
          styles.page7Content,
          lang == 'ar' ? styles.ar : ''
        )}
      >
        {!errorData ? (
          <>
            <p>{t('y信息页7-每月收听最多歌曲')}</p>
            <p>{t('y信息页7-The Hit of Months')}</p>

            {/* Render pages based on data availability */}
            {[0, 3, 6, 9].map((startIndex, pageNum) => {
              const pageData = page7Data.slice(startIndex, startIndex + 3)
              if (pageData.length === 0) return null

              return (
                <div
                  id={`m${pageNum + 1}`}
                  className={styles.part}
                  key={`page${pageNum}`}
                >
                  {pageData.map(
                    ({
                      monthly_hit,
                      monthly_play_cnt,
                      monthly_song_name,
                    }: {
                      monthly_hit: string
                      monthly_play_cnt: number
                      monthly_song_name: string
                    }) => (
                      <div
                        className="gsap"
                        key={`m${pageNum + 1}-${monthly_hit}`}
                      >
                        <div className={styles.svgs}>
                          <img
                            className={styles.line}
                            src={icLine.src}
                            alt=""
                          />
                          <img className={styles.dot} src={icDot.src} alt="" />
                        </div>
                        <div className={styles.txt}>
                          <div className={styles.m}>
                            {t(`简写${monthly_hit}月`)}
                          </div>
                          <i>
                            {monthly_song_name.length > 26
                              ? monthly_song_name.substring(0, 26) + ' ... '
                              : monthly_song_name}
                          </i>
                          <div className={styles.time}>
                            {monthly_play_cnt} {t('y信息页-times')}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              )
            })}
            {!fnBtn && <MoreInfo />}
          </>
        ) : (
          <p>{t('y信息页7-解析错误')}</p>
        )}
      </div>
    </>
  )
}

type Page8Props = {
  page8Data?: any
  pageIndex: number
  track: any
}
const RenderPage8: FC<Page8Props> = ({ track, page8Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 7) return
    track('$AppViewScreen', {
      $url: '/music_memories/explore_month',
      content_type: 'normal',
    })

    const p8 = document.getElementById('p8')
    const p9 = document.getElementById('p9')

    const elements = document.getElementById('p8')?.getElementsByTagName('p')
    const tl = gsap.timeline()

    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })
    p9 && gsap.set(p9, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p8,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    ).to(
      // @ts-ignore
      elements[0],
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
    return () => {
      gsap.set(p8, { y: 100, opacity: 0 })
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p8" className={styles.page8Content}>
        <p>
          {t('y信息页8-搜索月份')}
          <i style={{ marginRight: 0 }}>{t(`${page8Data.explorMonth}月`)}</i>
          <span>{t('y信息页8-总共有几首歌')}</span>
          <i className={styles.num}>{page8Data.explorMonSongCtd}</i>
          <span>{t('y信息页8-被收听')}</span>
        </p>
      </div>
    </>
  )
}

type Page9Props = {
  page9Data?: any
  pageIndex: number
  track: any
}

const RenderPage9: FC<Page9Props> = ({ track, page9Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)
  const haveValue =
    page9Data.firstFavoriteDt ||
    page9Data.lateNightTs ||
    page9Data.earlyMorningTs ||
    page9Data.singleLoopDt

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 8) return
    const elements = document.getElementById('p9')?.querySelectorAll('.gsap')
    const imgEle = document.getElementById('p9')?.getElementsByTagName('img')

    const p9 = document.getElementById('p9')
    const p10 = document.getElementById('p10')

    const tl = gsap.timeline()
    p10 && gsap.set(p10, { y: 100, opacity: 0 })
    elements && gsap.set(elements, { y: 100, opacity: 0 })

    imgEle && gsap.set(imgEle, { y: 100, opacity: 0 })

    page9Data.firstFavoriteDt &&
      track('$AppViewScreen', {
        $url: '/music_memories/special_like',
        content_type: 'normal',
      })

    if (page9Data.lateNightTs || page9Data.earlyMorningTs) {
      track('$AppViewScreen', {
        $url: '/music_memories/special_time',
        content_type: 'normal',
      })
    }

    page9Data.singleLoopDt &&
      track('$AppViewScreen', {
        $url: '/music_memories/special_single',
        content_type: 'normal',
      })

    // Initial animation
    tl.to(p9, { y: 0, opacity: 1, duration: 1, ease: 'power2.out' }, 1)

    if (elements && haveValue) {
      // Title animation
      tl.to(
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
        .to(
          // @ts-ignore
          imgEle?.[0],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          2
        )
        .to(
          // @ts-ignore
          imgEle?.[1],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          2
        )

      // Content animations
      if (elements[1]) {
        tl.to(
          elements[1],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          2
        )
      }
      if (elements[2]) {
        tl.to(
          elements[1],
          { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
          7
        ).to(
          elements[2],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          8
        )
      }
      if (elements[3]) {
        tl.to(
          elements[2],
          { y: -50, opacity: 0, duration: 1, ease: 'power2.out' },
          13
        ).to(
          elements[3],
          { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
          14
        )
      }
    } else {
      // Fallback animation for no data
      tl.to(
        // @ts-ignore
        elements?.[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      ).to(
        // @ts-ignore
        elements?.[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
    }

    return () => tl.kill()
  }, [pageIndex])

  // Helper function to render favorite moment
  const renderFavoriteMoment = () => (
    <div className={styles.part}>
      <div className={styles.svgs}>
        <img className={styles.line} src={icLine.src} alt="" />
        <img className={styles.dot} src={icDot.src} alt="" />
      </div>
      <div className="gsap">
        <span>
          {t('y信息页-On')}
          <i style={{ marginRight: 0 }}>
            {t(dayjs(page9Data.firstFavoriteDt).format('MMM'))}
          </i>
          <i>{dayjs(page9Data.firstFavoriteDt).format('D, YYYY')}</i>
          <span>{t('y信息页9-you enjoyed the song')}</span>
          <i className={styles.songName}>{page9Data.firstFavoriteSongName}</i>
          {page9Data.firstFavoriteArtistName && (
            <>
              <span>{t('y信息页-by')}</span>
              <i>{page9Data.firstFavoriteArtistName}</i>
            </>
          )}
        </span>
        <div>{t('y信息页9-so you add it as your favorite')}</div>
      </div>
    </div>
  )

  // Helper function to render listening time moment
  const renderListeningTimeMoment = () => {
    const isLateNight = !!page9Data.lateNightTs
    const timestamp = isLateNight
      ? page9Data.lateNightTs
      : page9Data.earlyMorningTs
    const songName = isLateNight
      ? page9Data.lateNightSongName
      : page9Data.earlyMorningSongName
    const artistName = isLateNight
      ? page9Data.lateNightArtistName
      : page9Data.earlyMorningArtistName

    return (
      <div className={styles.part}>
        <div className={styles.svgs}>
          <img className={styles.line} src={icLine.src} alt="" />
          <img className={styles.dot} src={icDot.src} alt="" />
        </div>
        <div className="gsap">
          {isLateNight ? (
            <span>
              {t('y信息页9-Do you remember')}
              <i style={{ marginRight: 0 }}>
                {t(dayjs.unix(timestamp).format('MMM'))}
              </i>
              <i>{dayjs.unix(timestamp).format('D, YYYY, H:mm A')}</i>
              <span>{t('y信息页9-when you vibed to')}</span>
              <i className={styles.songName}>{songName}</i>
              {artistName && (
                <>
                  <span>{t('y信息页-by')}</span>
                  <i style={{ marginRight: 0 }}>{artistName}</i>
                </>
              )}
              <span>{t('y信息页9-what was the mood that night')}</span>
            </span>
          ) : (
            <span>
              <span>{t('y信息页9-最早听歌时间')}</span>
              <i style={{ marginRight: 0 }}>
                {t(dayjs.unix(timestamp).format('MMM'))}
              </i>
              <i>{dayjs.unix(timestamp).format('D, YYYY, H:mm A')}</i>
              <span>{t('y信息页9-when you vibed to')}</span>
              <i className={styles.songName}>{songName}</i>
              {artistName && (
                <>
                  <span>{t('y信息页-by')}</span>
                  <i>{artistName}</i>
                </>
              )}
              <span>{t('y信息页9-music always brings')}</span>
            </span>
          )}
        </div>
      </div>
    )
  }

  // Helper function to render single loop moment
  const renderSingleLoopMoment = () => (
    <div className={styles.part}>
      <div className={styles.svgs}>
        <img className={styles.line} src={icLine.src} alt="" />
        <img className={styles.dot} src={icDot.src} alt="" />
      </div>
      <div className="gsap">
        <span>
          {t('y信息页-On')}
          <i style={{ marginRight: 0 }}>
            {t(dayjs(page9Data.singleLoopDt).format('MMM'))}
          </i>
          <i>{dayjs(page9Data.singleLoopDt).format('D, YYYY')}</i>
          <span>{t('y信息页9-you single-looped')}</span>
          <i className={styles.songName}>{page9Data.singleLoopSongName}</i>
          {page9Data.singleLoopArtName && (
            <>
              <span>{t('y信息页-by')}</span>
              <i>{page9Data.singleLoopArtName}</i>
            </>
          )}
          <span>{t('y信息页-for')}</span>
          <i>{page9Data.singleLoopPlayCnt}</i>
          <span>{t('y信息页-times')}.</span>
        </span>
        <div>{t('y信息页9-You got obsessed with the rhythm')}</div>
      </div>
    </div>
  )

  return (
    <div id="p9" className={styles.page9Content}>
      {haveValue ? (
        <>
          <div className="gsap">{t('y信息页9-特别时刻')}</div>
          {page9Data.firstFavoriteDt && renderFavoriteMoment()}
          {(page9Data.lateNightTs || page9Data.earlyMorningTs) &&
            renderListeningTimeMoment()}
          {page9Data.singleLoopDt && renderSingleLoopMoment()}
        </>
      ) : (
        <div className={styles.doudi}>
          <div className="gsap">{t('y信息页9-兜底1')}</div>
          <div className="gsap">{t('y信息页9-兜底2')}</div>
        </div>
      )}
    </div>
  )
}

type Page10Props = {
  page10Data?: any
  pageIndex: number
  track: any
}
const RenderPage10: FC<Page10Props> = ({ track, page10Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)
  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 9) return

    track('$AppViewScreen', {
      $url: '/music_memories/total_time_2024',
      content_type: 'normal',
    })
    const p10 = document.getElementById('p10')
    const p11 = document.getElementById('p11')

    const elements = document.getElementById('p10')?.getElementsByTagName('p')

    const tl = gsap.timeline()

    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })
    p11 && gsap.set(p11, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p10,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    ).to(
      // @ts-ignore
      elements[0],
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
    return () => {
      gsap.set(p10, { y: 100, opacity: 0 })
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p10" className={styles.page10Content}>
        <p>
          {t('y信息页10-These memories in 2024')}
          <i className={styles.num}>{page10Data.playMins}</i>
          <span style={{ marginRight: '5px' }}>{t('分钟')}</span>
          <span>{t('y信息页-and')}</span>
          <i className={styles.num}>{page10Data.totalPlaySong}</i>
          <span>{t('y信息页10-songs')}</span>
          {t('y信息页10-are now part of your')}
        </p>
      </div>
    </>
  )
}

type Page11Props = {
  page11Data?: any
  pageIndex: number
  track: any
}
const RenderPage11: FC<Page11Props> = ({ track, page11Data, pageIndex }) => {
  const { t, lang } = useTranslation(i18ns)

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 10) return

    track('$AppViewScreen', {
      $url: '/music_memories/lpdays',
      content_type: 'normal',
    })

    const p11 = document.getElementById('p11')
    const p12 = document.getElementById('p12')

    const elements = document.getElementById('p11')?.getElementsByTagName('p')

    const tl = gsap.timeline()

    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })
    p12 && gsap.set(p12, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p11,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
      .to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
      .to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
      .to(
        // @ts-ignore
        elements[2],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        3
      )
    return () => {
      gsap.set(p11, { y: 100, opacity: 0 })
      tl.kill()
    }
  }, [pageIndex])
  return (
    <>
      <div id="p11" className={styles.page11Content}>
        <p>{t('y信息页11-One more thing')}</p>
        {page11Data.firstUseLpDt ? (
          <p>
            <span>
              {t('y信息页11-This is the')}
              <i className={styles.num}>
                {dayjs(new Date()).diff(page11Data.firstUseLpDt, 'day')}
              </i>
              <span>{t('y信息页11-you have been using Lark Player')}</span>
            </span>
          </p>
        ) : (
          <p>
            {t(
              'y信息页11-You have been using Lark Player for more than 2000 days'
            )}
            {lang == 'ar' ? (
              ''
            ) : (
              <>
                {' '}
                <i>2000</i>
                {t('days')}
              </>
            )}
          </p>
        )}

        <p>{t('y信息页11-Nice to have you here')}</p>
      </div>
    </>
  )
}

type Page12Props = {
  page12Data?: any
  pageIndex: number
  track: any
  fnBtn?: boolean
  arRegion?: boolean
  MoreInfo: any
}
const RenderPage12: FC<Page12Props> = ({
  track,
  page12Data,
  pageIndex,
  fnBtn,
  MoreInfo,
  arRegion,
}) => {
  const { t, lang } = useTranslation(i18ns)
  const totalPlaySong =
    page12Data.totalPlaySong > 1000000 ? '1000000+' : page12Data.totalPlaySong

  // @ts-ignore
  useEffect(() => {
    if (pageIndex !== 11) return

    track('$AppViewScreen', {
      $url: '/music_memories/summary',
      content_type: 'normal',
    })

    const p12 = document.getElementById('p12')
    const elements = document.getElementById('p12')?.querySelectorAll('.gsap')

    const tl = gsap.timeline()

    // @ts-ignore
    gsap.set(elements, { y: 100, opacity: 0 })

    tl.to(
      // @ts-ignore
      p12,
      { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
      1
    )
      .to(
        // @ts-ignore
        elements[0],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        1
      )
      .to(
        // @ts-ignore
        elements[1],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        2
      )
      .to(
        // @ts-ignore
        elements[2],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        3
      )
      .to(
        // @ts-ignore
        elements[3],
        { y: 0, opacity: 1, duration: 1, ease: 'power2.out' },
        4
      )
      .to(
        // @ts-ignore
        elements[4],
        {
          y: 100,
          opacity: 1,
          duration: 1,
          ease: 'power2.out',
        },
        4.5
      )
    return () => {
      gsap.set(p12, { y: 100, opacity: 0 })
      tl.kill()
    }
  }, [pageIndex])

  return (
    // 结果汇总页
    <div id="p12" className={classnames(styles.page, styles.page12)}>
      <div className={styles.page12Content} dir={lang == 'ar' ? 'rtl' : 'ltr'}>
        <div className={styles.toplist}>
          <div className="gsap">
            <div className={styles.title}>
              <img src={icPlaytime.src} alt="" />
              <span> {t('y信息页12-Total Played Time')} </span>
            </div>
            <i>{page12Data.playMins}</i>
          </div>
          <div className="gsap">
            <div className={styles.title}>
              <img src={icSong.src} alt="" />
              <span> {t('y信息页12-Total Songs Played')} </span>
            </div>
            <i>{totalPlaySong}</i>
          </div>
        </div>

        <div className="gsap">
          <div className={styles.list}>
            <div className={styles.title}>
              <img src={icArtist.src} alt="" />
              <span>{t('y信息页12-Top Artists')}</span>
            </div>

            {page12Data.top5Artist &&
              page12Data.top5Artist.slice(0, 5).map((i: string, e: number) => (
                <i key={'topArt' + e}>
                  {lang == 'ar' ? t(`数字${e + 1}`) : e + 1}. {i}
                </i>
              ))}
          </div>
        </div>
        <div className="gsap">
          <div className={classnames(styles.list, arRegion && styles.ar)}>
            <div className={styles.title}>
              <img src={icRanking.src} alt="" />
              <span> {t('y信息页12-Top Songs')}</span>
            </div>

            {page12Data.top5Songs &&
              page12Data.top5Songs.slice(0, 5).map((i: string, e: number) => (
                <i key={'topSongs' + e}>
                  {lang == 'ar' ? t(`数字${e + 1}`) : e + 1}. {i}
                </i>
              ))}
          </div>
        </div>

        {/* 截图/分享时，显示海报文案 */}
        {!fnBtn && <MoreInfo />}
      </div>

      <div
        className="gsap"
        style={{
          position: 'absolute',
          height: '100%',
          top: '-15%',
          width: '100%',
          zIndex: 1,
        }}
      >
        <div className={styles.bg2024}></div>
      </div>
    </div>
  )
}

const Yearly: NextPage = () => {
  const { t, lang } = useTranslation(i18ns)
  const router = useRouter()
  const { from = '' } = router.query

  const {
    versionCode,
    accountInfo: { deviceId, region },
  } = useAppSelector(selectGlobal)

  const [page1Data, setPage1Data] = useState({
    firstPlay: 0,
    playMins: 0,
    playDay: 0,
  })
  const [page2Data, setPage2Data] = useState<any[]>([])
  const [page3Data, setPage3Data] = useState<any>({})
  const [page4Data, setPage4Data] = useState<any>({})
  const [page5Data, setPage5Data] = useState<any[]>([])
  const [page6Data, setPage6Data] = useState<any>({})
  const [page7Data, setPage7Data] = useState<any[]>([])
  const [page8Data, setPage8Data] = useState<any>({})
  const [page9Data, setPage9Data] = useState<any>({})
  const [page10Data, setPage10Data] = useState<any>({})
  const [page11Data, setPage11Data] = useState<any>({})
  const [page12Data, setPage12Data] = useState<any>({})
  const [audioPlay, setAudioPlay] = useState(false)
  const [fnBtn, setFnBtn] = useState(true)
  const [showSwiper, setSwiper] = useState(false)
  const [pageIndex, setPageIndex] = useState(0)
  const [showToast, setShowToast] = useState(false)
  const [lowVersion, setLowVersion] = useState(false)
  const [getDataTime, setGetTime] = useState(15000)
  const [hasAudio, setGetAudio] = useState(0)
  const [getDataList, setDataList] = useState(false)
  const [arRegion, setArRegion] = useState(false)
  const [noData, setNoData] = useState(false)

  const track = (event: string, params = {} as any) => {
    hybrid.trackEvent(event, {
      from,
      ...params,
    })
  }

  useEffect(() => {
    ;(async () => {
      onStartHandler()
      checkHttpLink(
        'https://s.nxtpen.com/larkplayer-campaigns/_next/static/media/ic_logo.f133f141.png'
      )
    })()
  }, [])

  useEffect(() => {
    const startTime = Date.now()

    ;(async () => {
      const getaudio = document.getElementById('myAudio')
      // 因为客户端弹窗，默认不播放h5音乐
      // @ts-ignore
      getaudio?.pause()
      getaudio && setGetAudio((Date.now() - startTime) / 1000)
      try {
        await hybrid.pause()
      } catch (error) {
        console.log('pause_error: ', error)
      }

      setTimeout(() => {
        setAudioPlay(true)
        // @ts-ignore
        getaudio?.play()
      }, 2000)
    })()
  }, [])

  // 客户端回调通知 activeSync({"state":100})
  // 100:截图成功 -100:截图失败  200:分享成功 -200:分享失败
  useEffect(() => {
    window.activeSync = (command: string) => {
      const { state }: { state: string } = JSON.parse(command)
      console.log(`客户端通知～${state}`)
      // @ts-ignore
      if (state == 100) {
        // 显示截图成功弹窗
        setShowToast(true)
        setFnBtn(true)
        setTimeout(() => {
          setShowToast(false)
        }, 2000)
      }
    }
  }, [])

  const urlList = [
    '/music_memories/begin',
    '/music_memories/top1_song',
    '/music_memories/song_topn',
    '/music_memories/top1_artist',
    '/music_memories/artist_topn',
    '/music_memories/playlist',
    '/music_memories/month_hit',
    '/music_memories/explore_month',
    '/music_memories/special',
    '/music_memories/total_time_2024',
    '/music_memories/lpdays',
    '/music_memories/summary',
  ]

  const urltrack = showSwiper
    ? urlList[pageIndex]
    : '/music_memories/home/waiting'

  const audioControl = async () => {
    const getaudio = document.getElementById('myAudio')
    // @ts-ignore
    if (audioPlay) {
      track('Click', {
        action: 'click_music_report_bgm_close',
        $url: urltrack,
      })
      setAudioPlay(false)
      // @ts-ignore
      getaudio?.pause()
      console.log('music pause ~')
    } else {
      track('Click', {
        action: 'click_music_report_bgm_open',
        $url: urltrack,
      })
      console.log('music play ~')
      setAudioPlay(true)
      // @ts-ignore
      getaudio?.play()
      try {
        await hybrid.pause()
      } catch (error) {
        console.log('pause_error: ', error)
      }
    }
  }

  // 截图功能 handleAction, 截图时隐藏页面按钮:返回/声音/下载/分享
  const screenShot = async () => {
    setFnBtn(false)
    track('Click', {
      action: 'click_music_report_download',
      $url: urltrack,
    })
    try {
      await hybrid.handleAction(
        'larkplayer://h5/event?action=show_dialog&type=1'
      )
    } catch (error) {
      console.log('screenshot_loading: ', error)
    }
    setTimeout(async () => {
      try {
        await hybrid.handleAction(
          'larkplayer://h5/event?action=screenshot&img_name=test1&ac_name=xxx&from=xxx'
        )
      } catch (error) {
        console.log('screenshot_error: ', error)
      }
    }, 500)
  }

  // 截图成功后弹窗提示
  const Toast = () => {
    return <div className={styles.toast}>{t('截图成功')}</div>
  }

  const gotoHomePage = async () => {
    !showSwiper &&
      track('Click', {
        action: 'exit_music_report_waiting',
        $url: '/music_memories/home/waiting',
        trigger_tag: 'back',
      })

    try {
      await hybrid.back()
    } catch (error) {
      console.log('error: ', error)
    }
  }

  const homeStart = () => {
    track('Click', {
      action: 'click_music_report_home_start',
      $url: '/music_memories/home/start',
    })
    getDataList && setSwiper(true)
  }

  const convertStringToJson = (input: string) => {
    // 将字符串中的单引号替换为双引号
    const formattedInput = input.replace(/'/g, '"')

    try {
      // 解析为 JSON 对象
      const jsonObject = JSON.parse(formattedInput)
      return jsonObject
    } catch (error) {
      // console.error('Error parsing JSON:', error)
      track('$AppViewScreen', {
        $url: '/music_memories/month_p1',
        content_type: 'error',
      })
      return null
    }
  }

  const onStartHandler = async () => {
    let newRegion = ''

    //
    const trackParams: any = {
      action: 'exit_music_report_waiting',
      $url: '/music_memories/home/waiting',
    }
    const startTime = Date.now()

    try {
      const deviceId = await hybrid.getUDID()
      // const deviceId = 'ad7b2ed86752fa4c1a585078fd9295d6'
      const res = await API.getMusicReport({
        deviceId,
        type: 'yearly',
        dt: '2024',
      })

      // 前置校验
      // 610版本号以下不显示部分按钮
      const versionCode = await hybrid.getThisVersionCode()
      if (versionCode < 26100000) {
        setLowVersion(true)
      }

      const region = await hybrid.getRegion()
      const isInRegion = regionList?.indexOf(region) > -1
      const isArRegion = arRegionList?.indexOf(region) > -1

      // 无数据： 1.用户region不在覆盖国家列表里, 2.用户的region在年报覆盖国家列表里但未达到时长
      if (res.total_play_day_cnt === 0) {
        if (!isInRegion) {
          router.push(
            `/music-recap/yearly/error?lang=${lang}&code=1&from=${from}`
          )
          return
        } else {
          router.push(
            `/music-recap/yearly/error?lang=${lang}&code=2&from=${from}`
          )
          return
        }
      }

      // 语言非阿语&在阿语区 lang !=='ar'&& isArRegion
      if (lang !== 'ar' && isArRegion) {
        setArRegion(true)
      }

      newRegion = res.new_region

      if (res) {
        setDataList(true)
        track('$AppViewScreen', {
          $url: '/music_memories/home/start',
          content_type: 'normal',
        })

        // @ts-ignore
        const artList = res.top_n_artist.slice(0, 5).map((e) => ({ title: e }))

        // @ts-ignore
        const songList = res.top_n_song_name
          .slice(0, 5)
          .map((e) => ({ title: e }))

        trackParams.report_info = {
          time: res.total_play_minutes,
          music_count: res.total_play_song_ctd,
        }

        artList.forEach((e: any, i: number) => {
          trackParams.report_info[`music_top${i + 1}`] = e.title.substring(
            0,
            30
          )
        })

        songList.forEach((e: any, i: number) => {
          trackParams.report_info[`artist_top${i + 1}`] = e.title.substring(
            0,
            30
          )
        })
      }

      setPage1Data({
        firstPlay: res.first_play_ts,
        playMins: res.total_play_minutes,
        playDay: res.total_play_day_cnt,
      })

      if (res.top_n_artist && res.top_n_artist.length > 0) {
        setPage2Data(res.top_n_artist)
      }

      setPage3Data({
        top1SongArt: res.top_n_artist[0],
        top1SongPlayDay: res.top_1_artist_play_day_cnt,
        top1SongPlayMin: res.top_1_artist_play_minutes,
        explorArt: res.explor_artist_name,
        explorSong: res.explor_artist_song_ctd,
      })

      setPage4Data({
        totalPlaySong: res.total_play_song_ctd,
        top1SongName: res.top_n_song_name[0],
        top1SongArt: res.top_1_song_artist_name,
        top1PlayCnt: res.top_1_song_play_cnt,
      })

      setPage5Data(res.top_n_song_name)

      if (res.top_1_playlist_name) {
        setPage6Data({
          top1PlaylistName: res.top_1_playlist_name,
          top1PlaylistMin: res.top_1_playlist_minutes,
        })
      }

      {
        res.top_n_artist[0] && res.explor_artist_name && (timeList.page4 = 12)
        res.explor_artist_song_ctd && (timeList.page2 = 14)
        res.top_n_artist && res.top_n_artist.length > 5 && (timeList.page5 = 16)
        res.top_n_song_name &&
          res.top_n_song_name.length > 5 &&
          (timeList.page3 = 16)
      }

      if (res && res.monthly_hit) {
        const monthlyHit = res.monthly_hit.map((item) =>
          convertStringToJson(item)
        )
        //  过滤为null的数据, 特殊字符过滤完后可能为空[]:有且只有一条数据&解析错误
        const filterList = monthlyHit.filter((e) => e !== null)

        if (filterList.length > 0) {
          setPage7Data(filterList)
          {
            filterList.slice(3, 6).length > 0 && (timeList.page7 = 19)
            filterList.slice(6, 9).length > 0 && (timeList.page7 = 27)
            filterList.slice(9, 12).length > 0 && (timeList.page7 = 35)
          }
        } else {
          setNoData(true)
          timeList.page7 = 6
        }
      }

      if (res.explor_month) {
        setPage8Data({
          explorMonth: res.explor_month,
          explorMonSongCtd: res.explor_month_song_ctd,
        })
      }

      if (
        res.first_favorite_dt ||
        res.early_morning_ts ||
        res.late_night_ts ||
        res.single_loop_dt
      ) {
        setPage9Data({
          firstFavoriteDt: res.first_favorite_dt && res.first_favorite_dt,
          firstFavoriteSongName: res.first_favorite_song_name,
          firstFavoriteArtistName: res.first_favorite_artist_name,
          earlyMorningTs: res.early_morning_ts !== 0 && res.early_morning_ts,
          earlyMorningSongName: res.early_morning_song_name,
          earlyMorningArtistName: res.early_morning_artist_name,
          lateNightTs: res.late_night_ts !== 0 && res.late_night_ts,
          lateNightSongName: res.late_night_song_name,
          lateNightArtistName: res.late_night_artist_name,
          singleLoopDt: res.single_loop_dt && res.single_loop_dt,
          singleLoopSongName: res.single_loop_song_name,
          singleLoopArtName: res.single_loop_artist_name,
          singleLoopPlayCnt: res.single_loop_play_cnt,
        })

        res.first_favorite_dt &&
          (res.early_morning_ts !== 0 ||
            res.late_night_ts !== 0 ||
            res.single_loop_dt) &&
          (timeList.page9 = 13)

        res.first_favorite_dt &&
          (res.early_morning_ts !== 0 || res.late_night_ts !== 0) &&
          res.single_loop_dt &&
          (timeList.page9 = 19)
      }

      setPage10Data({
        playMins: res.total_play_minutes,
        totalPlaySong: res.total_play_song_ctd,
      })

      setPage11Data({
        firstUseLpDt: res.first_use_lp_dt,
      })

      setPage12Data({
        playMins: res.total_play_minutes,
        totalPlaySong: res.total_play_song_ctd,
        top5Artist: res.top_n_artist,
        top5Songs: res.top_n_song_name,
      })
    } catch (e: any) {
      // 错误重试
      console.log('e', e)
      trackParams.trigger_tag = 'error_popup'
      trackParams.error = e.message || '「获取错误信息失败」'
      track('Click', trackParams)
      router.push(`/music-recap/yearly/error?lang=${lang}&code=3&from=${from}`)
      return
    }

    // 返回数据时间
    const curTime = (Date.now() - startTime) / 1000
    // @ts-ignore
    trackParams.arg2 = {
      loading_duration: curTime,
      images_duration: hasAudio,
    }
    trackParams.trigger_tag = 'complete_loading'
    trackParams.arg2 = JSON.stringify(trackParams.arg2)
    trackParams.report_info = JSON.stringify(trackParams.report_info)

    setGetTime(curTime)

    track('Click', trackParams)

    // 如果等待时间超15秒
    if (curTime > 15000) {
      router.push(`/music-recap/yearly/error?lang=${lang}&code=3&from=${from}`)
      return
    }
  }

  const buildDeepLink = (url: string) => {
    let link = 'https://campaigns.nxtpen.com/deeplink?action='
    const directUrl = encodeURIComponent(intent.getH5Page(url))
    link += directUrl

    const utm_query = `&utm_source=share_music_memories&utm_campaign=h5share&utm_medium=jump_gp&utm_term=share_button`

    const gpLink = encodeURIComponent(intent.getGPlink(utm_query))

    link += `&scheme=larkplayer&package=com.dywx.larkplayer&fallback_url=${gpLink}`
    return link
  }

  // 资源检测
  const checkHttpLink = async (url: string) => {
    try {
      const response = await axios.get(url)
      return response.status >= 200 && response.status < 300
    } catch (error) {
      track('$AppViewScreen', {
        $url: '/music_memories/home/source',
        content_type: 'error',
        // @ts-ignore
        error: error?.message,
        arg1: url,
        event_url: window.location.host,
      })
    }
  }

  const onShare = async () => {
    track('Share', {
      action: 'click_share',
      $url: urltrack,
    })

    // 点击分享时隐藏页面按钮:返回/声音/下载/分享
    !lowVersion && setFnBtn(false)

    try {
      await hybrid.handleAction(
        'larkplayer://h5/event?action=show_dialog&type=1'
      )
    } catch (error) {
      console.log('screenshot_loading: ', error)
    }

    const link = `${location.origin}/music-recap/yearly?lang=${lang}&from=deeplink`

    const sharedLink = buildDeepLink(link)

    const { data } = await axios({
      method: 'POST',
      url: 'https://larkplayer.link/generate',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        url: sharedLink,
      },
    })

    // 分享完后显示按钮
    setTimeout(() => {
      setFnBtn(true)
    }, 3500)

    console.log('data', data)

    const sharelink = !lowVersion
      ? await hybrid.shareLinkLP({
          // 分享+截图功能合并: desc 放文案和短链
          desc: JSON.stringify({
            title: t('y分享出去的文案'),
            url: data?.shortUrl ? data.shortUrl : link,
          }),
          urlLink:
            'larkplayer://h5/event?action=screenshot_and_share&img_name=test2',
          // @ts-ignore
          source: 'music_yearly',
        })
      : await hybrid.shareLinkLP({
          desc: t('y分享出去的文案'),
          urlLink: data?.shortUrl ? data.shortUrl : link,
          source: 'music_yearly',
        })

    console.log('sharelink', sharelink)
  }

  const MoreInfo = () => {
    return (
      <div className={styles.moreInfo} dir={lang == 'ar' ? 'rtl' : 'ltr'}>
        {t('y海报文案')}
      </div>
    )
  }

  // 结果页
  const resultLayout = ({
    page,
    style = {},
    content,
  }: {
    page: number
    style?: CSSProperties
    content: ReactNode
  }) => {
    return (
      <div
        className={classnames(styles.page, styles[`page${page}`])}
        dir={lang == 'ar' ? 'rtl' : 'ltr'}
      >
        {content}
        {/* 截图弹窗 */}
        {/* {!fnBtn && <MoreInfo />} */}
        {/* {showToast && <Toast />} */}

        {/* 截图和分享 */}
        {/* {fnBtn && !lowVersion && (
          <div className={styles.fnBox}>
            <div className={styles.box} onClick={onShare}>
              <img className={styles.icShare} src={icShare.src} alt="" />
              <div className={styles.btn}>{t('分享按钮')}</div>
            </div>

            <img
              className={styles.icDownload}
              src={icDownload.src}
              alt=""
              onClick={screenShot}
            />
          </div>
        )} */}
      </div>
    )
  }

  const renderPage1 = (pageIndex: number) => {
    return resultLayout({
      page: 1,
      content: (
        <RenderPage1
          track={track}
          page1Data={page1Data}
          pageIndex={pageIndex}
          fnBtn={fnBtn}
          MoreInfo={MoreInfo}
        />
      ),
    })
  }
  const renderPage2 = (pageIndex: number) => {
    return resultLayout({
      page: 2,
      content: (
        <RenderPage2
          track={track}
          page2Data={page2Data}
          pageIndex={pageIndex}
          fnBtn={fnBtn}
          MoreInfo={MoreInfo}
        />
      ),
    })
  }
  const renderPage3 = (pageIndex: number) => {
    return resultLayout({
      page: 3,
      content: (
        <RenderPage3
          track={track}
          page3Data={page3Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage4 = (pageIndex: number) => {
    return resultLayout({
      page: 4,
      content: (
        <RenderPage4
          track={track}
          page4Data={page4Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage5 = (pageIndex: number) => {
    return resultLayout({
      page: 5,
      content: (
        <RenderPage5
          track={track}
          page5Data={page5Data}
          pageIndex={pageIndex}
          fnBtn={fnBtn}
          MoreInfo={MoreInfo}
        />
      ),
    })
  }

  const renderPage6 = (pageIndex: number) => {
    return resultLayout({
      page: 6,
      content: (
        <RenderPage6
          track={track}
          page6Data={page6Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage7 = (pageIndex: number) => {
    return resultLayout({
      page: 7,
      content: (
        <RenderPage7
          track={track}
          page7Data={page7Data}
          pageIndex={pageIndex}
          fnBtn={fnBtn}
          MoreInfo={MoreInfo}
          errorData={noData}
        />
      ),
    })
  }

  const renderPage8 = (pageIndex: number) => {
    return resultLayout({
      page: 8,
      content: (
        <RenderPage8
          track={track}
          page8Data={page8Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage9 = (pageIndex: number) => {
    return resultLayout({
      page: 9,
      content: (
        <RenderPage9
          track={track}
          page9Data={page9Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage10 = (pageIndex: number) => {
    return resultLayout({
      page: 10,
      content: (
        <RenderPage10
          track={track}
          page10Data={page10Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage11 = (pageIndex: number) => {
    return resultLayout({
      page: 11,
      content: (
        <RenderPage11
          track={track}
          page11Data={page11Data}
          pageIndex={pageIndex}
        />
      ),
    })
  }

  const renderPage12 = (pageIndex: number) => {
    return (
      <div style={{ width: '100%' }} className={styles.page12Info}>
        <RenderPage12
          track={track}
          page12Data={page12Data}
          pageIndex={pageIndex}
          fnBtn={fnBtn}
          MoreInfo={MoreInfo}
          arRegion={arRegion}
        />

        {/* 截图弹窗 */}
        {/* <MoreInfo /> */}
        {/* {!fnBtn && <MoreInfo />} */}

        {/* {showToast && <Toast />} */}

        {/* {fnBtn && (
          <div className={styles.fnBox}>
            <div className={styles.box} onClick={onShare}>
              <img className={styles.icShare} src={icShareBlack.src} alt="" />
              <div className={styles.btn}>{t('分享按钮')}</div>
            </div>
            {!lowVersion && (
              <img
                className={styles.icDownload}
                src={icDownload.src}
                alt=""
                onClick={screenShot}
              />
            )}
          </div>
        )} */}
      </div>
    )
  }
  // 11/30调整页面顺序：2,3,4,5 -> 4,5,3,2
  const resultList = (pageIndex: number) => [
    renderPage1(pageIndex),
    renderPage4(pageIndex),
    renderPage5(pageIndex),
    renderPage3(pageIndex),
    page2Data && renderPage2(pageIndex),
    renderPage6(pageIndex),
    renderPage7(pageIndex),
    page8Data && renderPage8(pageIndex),
    page9Data && renderPage9(pageIndex),
    renderPage10(pageIndex),
    renderPage11(pageIndex),
    renderPage12(pageIndex),
  ]

  return (
    <Div100vh
      className={classnames(
        styles.yearly,
        showSwiper &&
          (pageIndex == 0 ? styles.page0 : styles[`page${pageIndex}`])
      )}
    >
      <div style={{ height: '100%' }}>
        <div className={styles.lbg}></div>
        <div className={styles.top}>
          <img className={styles.logo} src={icLogo.src} alt="" />
          <div
            className={styles.topRight}
            style={{ visibility: fnBtn ? 'visible' : 'hidden' }}
          >
            {showSwiper && pageIndex == 11 && (
              <img
                className={styles.icReplay}
                src={icRefresh.src}
                alt=""
                onClick={() => {
                  setSwiper(false)
                  setPageIndex(0)
                }}
              />
            )}
            <div className={styles.audio} onClick={audioControl}>
              <audio
                id="myAudio"
                src="https://s.nxtpen.com/larkplayer-campaigns/music/bg.mp3"
                autoPlay={audioPlay}
                loop
              ></audio>
              <img
                className={styles.icSound}
                src={audioPlay ? icSound.src : icMuted.src}
                alt=""
              />
            </div>
            <img
              className={styles.close}
              src={icClose.src}
              alt=""
              onClick={gotoHomePage}
            />
          </div>
        </div>

        {/* 轮播图 */}
        {showSwiper ? (
          <MySwiper
            show={fnBtn}
            onPageIndex={(index) => {
              setPageIndex(index)
            }}
            timeList={timeList}
            // replay={isReplay}
            data={() => resultList(pageIndex)}
          />
        ) : (
          <RenderPage0
            dataTime={getDataTime}
            track={track}
            onClick={homeStart}
          />
        )}

        {showSwiper &&
          (pageIndex == 0 ||
            pageIndex == 2 ||
            pageIndex == 4 ||
            (!noData && pageIndex == 6) ||
            pageIndex == 11) &&
          showToast && <Toast />}

        {!lowVersion &&
          showSwiper &&
          fnBtn &&
          (pageIndex == 0 ||
            pageIndex == 2 ||
            pageIndex == 4 ||
            (!noData && pageIndex == 6) ||
            pageIndex == 11) && (
            <div className={styles.fnBox}>
              <div className={styles.box} onClick={onShare}>
                <img
                  className={styles.icShare}
                  src={icShareBlack.src}
                  // src={pageIndex == 11 ? icShareBlack.src : icShare.src}
                  alt=""
                />
                <div className={styles.btn}>{t('分享按钮')}</div>
              </div>
              <img
                className={styles.icDownload}
                src={icDownload.src}
                alt=""
                onClick={screenShot}
              />
            </div>
          )}

        {/* 低版本只有最后一页显示分享按钮 */}
        {lowVersion && pageIndex == 11 && (
          <div className={styles.fnBox}>
            <div className={styles.box} onClick={onShare}>
              <img
                className={styles.icShare}
                src={pageIndex == 11 ? icShareBlack.src : icShare.src}
                alt=""
              />
              <div className={styles.btn}>{t('分享按钮')}</div>
            </div>
          </div>
        )}
      </div>
    </Div100vh>
  )
}

Yearly.getInitialProps = () => {
  return { ns: i18ns }
}

export default Yearly
